import styled from 'styled-components';
import { TextField } from 'material-ui';
import Modal from '../../../../components/Modal';
import AlertMessage from '../../../../components/AlertMessage';
import Button from '../../../../components/Button';
import { ChangeCircleOutlined, ExitToApp } from '@mui/icons-material';

export const StyledModal = styled(Modal)`
  max-height: 80vh;
  overflow: auto;
`;

export const DivideLine = styled.div`
  border-bottom: 1px solid var(--gray-light);
  margin-top: 16px;
  margin-right: -24px;
  margin-left: -24px;
`;

export const TextFieldStyled = styled(TextField)`
  font-size: 14px;
`;

export const AlertMessageStyled = styled(AlertMessage)`
  margin-bottom: 8px;
`;

export const SelectCompanyModalHeader = styled.div`
   padding: 10px 24px 0px 24px;
`;

export const PopoverContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid var(--gray-light);
`;

export const Popover = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
`;

export const AvatarContainer = styled.div`
  display: flex;
  width: 56px;
  padding-right: 32px;
  flex-direction: column;
  align-items: flex-start;
`;

export const UserContainer = styled.div`
  display: flex;
  padding: 4px 0px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

export const FirstText = styled.div`
  font-size: 16px;
`;

export const SecondText = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.60);
`;

export const CarbonContentContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-bottom: 1px solid var(--gray-light);
`;

export const Item = styled.div`
  display: flex;
  padding: 4px 0px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
`;

export const PlatformActionsContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

export const ChangeClientText = styled.div`
  color: rgba(0, 0, 0, 0.54);
  font-size: 16px;
`;

export const ExitPlatformText = styled.div`
  color: #E31B0C;
  font-size: 16px;
`;

export const IconContainer = styled.div`
  display: flex;
  padding-right: 32px;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledChangeCircleOutlined = styled(ChangeCircleOutlined)`
  width: 24px;
  height: 24px;
  color: #0000008A;
`;

export const StyledExitToApp = styled(ExitToApp)`
  width: 24px;
  height: 24px;
  color: #E31B0C;
`;
